import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Link,
    Typography,
    Button
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../Common/ConfirmDialog";
import ClearIcon from "@mui/icons-material/Clear";
export default function History({
    resultDataMap,   
    rows,
    parameters,
    setResultDataMap
}) {

    const navigate = useNavigate();

    const [selectedRun, setSelectedRun] = useState(null);

    const fields = ["B0", "B1", "B2", "B3", "B4", "R2", "A0", "A1", "A2", "A3", "Cmin", "Cmax", "X", "Y", "Y2","K"];
  
    const historyData = Object.values(resultDataMap || {});
    const [openClearDialog, setOpenClearDialog] = useState(false);
    /* ---------------- AUTO SELECT LATEST RUN ---------------- */
    useEffect(() => {

        const runs = Object.keys(resultDataMap || {});

        if (runs.length > 0) {

            const latestRun = Number(runs[runs.length - 1]);

            setSelectedRun(latestRun);
        }

    }, [resultDataMap]);

    const selectedEntry = resultDataMap?.[selectedRun];

    const selectedResult = selectedEntry?.result;

    const selectedDescription = selectedEntry?.description;

    const handleClearClick = () => {
        setOpenClearDialog(true);
    };
    const handleConfirmClear = () => {
        setResultDataMap({}); // UI reset
        sessionStorage.removeItem("calibrationHistory"); // storage reset
        setOpenClearDialog(false);
    };
    const handleCancelClear = () => {
        setOpenClearDialog(false);
    };
    return (
        <Box
            sx={{
                display: "flex",
                gap: 2,
                flexDirection: {
                    xs: "column",
                    md: "row"
                }
            }}
        >

            {/* ---------------- RESULT PANEL ---------------- */}
            <Paper
                sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300
                }}
            >

                <Typography
                    variant="h6"
                    gutterBottom
                >
                    Result {selectedRun
                        ? `( ${selectedDescription})`
                        : ""}
                </Typography>

                {selectedResult ? (

                    <Table size="small">

                        <TableBody>

                            {fields.map((field) => (

                                <TableRow key={field}>

                                    <TableCell>
                                        <strong>{field}</strong>
                                    </TableCell>

                                    <TableCell>
                                        {selectedResult?.[field] ?? "-"}
                                    </TableCell>

                                </TableRow>

                            ))}

                        </TableBody>

                    </Table>

                ) : (

                    <Typography>
                        No Result Data
                    </Typography>

                )}

            </Paper>

            {/* ---------------- HISTORY PANEL ---------------- */}
            <Paper
                sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                >

                    <Typography variant="h6">
                        History
                    </Typography>

                    <Button
                        size="small"
                        
                        color="error"
                        onClick={handleClearClick}
                        startIcon={<ClearIcon />}
                        disabled={!Object.keys(resultDataMap || {}).length}
                        variant="contained"
                        sx={{
                            backgroundColor:
                                "#774def"
                        }}

                    >
                        Clear History
                    </Button>

                </Box>

                {historyData.length > 0 ? (

                    <TableContainer>

                        <Table size="small">

                            <TableHead>

                                <TableRow>

                                    <TableCell>
                                        Run
                                    </TableCell>

                                    <TableCell>
                                        Description
                                    </TableCell>

                                    <TableCell>
                                        Report
                                    </TableCell>
                                   
                                    <TableCell>
                                        Prediction
                                    </TableCell>
                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {historyData.map((row) => (

                                    <TableRow
                                        key={row.run}
                                        hover
                                        selected={
                                            row.run === selectedRun
                                        }
                                        onClick={() =>
                                            setSelectedRun(row.run)
                                        }
                                        sx={{
                                            cursor: "pointer"
                                        }}
                                    >

                                        <TableCell>
                                            {row.run}
                                        </TableCell>

                                        <TableCell>
                                            {row.description || "-"}
                                        </TableCell>

                                        {/* REPORT NAVIGATION */}
                                        <TableCell>

                                            <Link
                                                component="button"
                                                onClick={(e) => {

                                                    e.stopPropagation();

                                                    navigate(
                                                        "/CalibrationReport",
                                                        {
                                                            state: {
                                                                openPredictionTab: false,

                                                                runData: row,

                                                                rows,

                                                                parameters,

                                                                calibrationResponse: row?.result
                                                            }
                                                        }
                                                    );
                                                }}
                                            >
                                                Launch
                                            </Link>

                                        </TableCell>

                                        {/* PREDICTION NAVIGATION */}
                                        <TableCell>

                                            <Link
                                                component="button"
                                                onClick={(e) => {

                                                    e.stopPropagation();

                                                    // Get existing session history
                                                    const prevData = JSON.parse(
                                                        sessionStorage.getItem("calibrationHistory") || "{}"
                                                    );

                                                    // Use proper run id
                                                    const runId =
                                                        row?.run ||
                                                        row?.runId ||
                                                        row?.id;

                                                    if (!runId) {

                                                        console.error("Run ID not found");

                                                        return;
                                                    }

                                                    // Save latest row data
                                                    const updated = {
                                                        ...prevData,
                                                        [runId]: {
                                                            ...row,
                                                            rows: row?.rows || rows || [],
                                                            parameters:
                                                                row?.parameters || parameters || []
                                                        }
                                                    };

                                                    sessionStorage.setItem(
                                                        "calibrationHistory",
                                                        JSON.stringify(updated)
                                                    );

                                                    console.log("Navigating with runId:", runId);

                                                    navigate("/MicroTip", {
                                                        state: {
                                                            openPredictionTab: true,
                                                            runId: runId
                                                        }
                                                    });
                                                }}
                                            >
                                                Launch
                                            </Link>

                                        </TableCell>
                                      
                                    </TableRow>

                                ))}

                            </TableBody>

                        </Table>

                    </TableContainer>

                ) : (

                    <Typography>
                        No History Available
                    </Typography>

                )}

            </Paper>
            <ConfirmDialog
                open={openClearDialog}
                title="Clear History"
                message="Are you sure you want to delete all history records? This action cannot be undone."
                onCancel={handleCancelClear}
                onConfirm={handleConfirmClear}
            />
        </Box>
    );
}